// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ConfigsComparePage_ConfigFragmentDoc } from '../../ProductOfferingConfigsComparePage.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductOfferingCardQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ProductOfferingCardQuery = { __typename?: 'Query', productOfferingConfig: { __typename?: 'ProductOfferingConfig', id: string, name: string, totalCostInCents: number, isBaseConfig: boolean, productOffering: { __typename?: 'ProductOffering', id: string, name: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined }, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, stories?: number | null | undefined, garageAttached?: number | null | undefined, garageDetached?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined, imperviousSqft?: number | null | undefined, minLotSizeInSqft?: number | null | undefined, minLotWidthInFeet?: number | null | undefined, minLotDepthInFeet?: number | null | undefined } } };


export const ProductOfferingCardDocument = gql`
    query ProductOfferingCard($id: ID!) {
  productOfferingConfig(id: $id) {
    ...ConfigsComparePage_Config
  }
}
    ${ConfigsComparePage_ConfigFragmentDoc}`;

/**
 * __useProductOfferingCardQuery__
 *
 * To run a query within a React component, call `useProductOfferingCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductOfferingCardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingCardQuery, ProductOfferingCardQueryVariables> & ({ variables: ProductOfferingCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingCardQuery, ProductOfferingCardQueryVariables>(ProductOfferingCardDocument, options);
      }
export function useProductOfferingCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingCardQuery, ProductOfferingCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingCardQuery, ProductOfferingCardQueryVariables>(ProductOfferingCardDocument, options);
        }
// @ts-ignore
export function useProductOfferingCardSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingCardQuery, ProductOfferingCardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingCardQuery, ProductOfferingCardQueryVariables>;
export function useProductOfferingCardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingCardQuery, ProductOfferingCardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingCardQuery | undefined, ProductOfferingCardQueryVariables>;
export function useProductOfferingCardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingCardQuery, ProductOfferingCardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingCardQuery, ProductOfferingCardQueryVariables>(ProductOfferingCardDocument, options);
        }
export type ProductOfferingCardQueryHookResult = ReturnType<typeof useProductOfferingCardQuery>;
export type ProductOfferingCardLazyQueryHookResult = ReturnType<typeof useProductOfferingCardLazyQuery>;
export type ProductOfferingCardSuspenseQueryHookResult = ReturnType<typeof useProductOfferingCardSuspenseQuery>;
export type ProductOfferingCardQueryResult = Apollo.QueryResult<ProductOfferingCardQuery, ProductOfferingCardQueryVariables>;